const ORIGIN_CONFIG: Record<string, { region: string; baseUrl: string }> = {
  'http://localhost:4200': { region: 'local', baseUrl: 'https://dev.hezkytech.com/' },
  'https://stage.hezky.ai': { region: 'us', baseUrl: 'https://stage.hezky.ai/' },
};

const config = ORIGIN_CONFIG[window.location.origin];
console.log(window.location.origin);
console.log(ORIGIN_CONFIG);

export const region = config.region;

export const environment = {
  production: false,
  baseUrl: config.baseUrl,
  origin: 'stage',
};
